import * as React from 'react';
import { View, Text, Modal } from 'react-native';
import { Icon } from 'react-native-elements';
import { CheckBox } from 'react-native-elements/dist/checkbox/CheckBox';
import { styles } from 'styles/components/orderStatusActionMenu';
import OrderStatusActionMenuProps from 'types/components/OrderStatusActionMenuProps';
import { useTranslation } from 'react-i18next';

export default ({
  handleFilter,
  visible,
  setVisible,
  selectedCheckbox,
  setSelectedCheckbox,
  isMediumScreen,
}: OrderStatusActionMenuProps): JSX.Element => {
  const renderModal = (): JSX.Element => {
    const { t } = useTranslation();
    return (
      <View style={isMediumScreen ? styles.modalContentLarge : styles.modalContentSmall}>
        <View style={styles.closeIconContainer}>
          <Icon
            name="close"
            type="ionicon"
            color={'#001639'}
            size={30}
            onPress={() => {
              setVisible(false);
            }}
          />
        </View>
        {isMediumScreen && (
          <View style={styles.titleContainer}>
            <Text style={styles.textTitle}>{t('status')}</Text>
            <Text style={styles.textTitleArrow}>↑</Text>
          </View>
        )}
        <View style={[styles.checkBoxOutsideContainer, { marginBottom: isMediumScreen ? 5 : 0 }]}>
          <CheckBox
            center={true}
            title={t('pending')}
            textStyle={{
              fontSize: 14,
              fontWeight: '400',
              lineHeight: 24,
              letterSpacing: 0,
              textAlign: 'left',
              color: '#001639',
            }}
            checkedColor={'#001639'}
            uncheckedColor={'#001639'}
            checked={selectedCheckbox === 'Pending'}
            onPress={() => {
              if (selectedCheckbox === 'Pending') {
                setSelectedCheckbox('');
                handleFilter('');
              } else {
                setSelectedCheckbox('Pending');
                handleFilter('Pending');
              }
            }}
            containerStyle={styles.checkBoxInsideContainer}
          />
        </View>
        <View style={[styles.checkBoxOutsideContainer, { marginBottom: isMediumScreen ? 5 : 0 }]}>
          <CheckBox
            center={true}
            title={t('in-proccess')}
            textStyle={{
              fontSize: 14,
              fontWeight: '400',
              lineHeight: 24,
              letterSpacing: 0,
              textAlign: 'left',
              color: '#001639',
            }}
            checked={selectedCheckbox === 'In Process'}
            checkedColor={'#001639'}
            uncheckedColor={'#001639'}
            onPress={() => {
              if (selectedCheckbox === 'In Process') {
                setSelectedCheckbox('');
                handleFilter('');
              } else {
                setSelectedCheckbox('In Process');
                handleFilter('In Process');
              }
            }}
            containerStyle={styles.checkBoxInsideContainer}
          />
        </View>
        <View style={[styles.checkBoxOutsideContainer, { marginBottom: isMediumScreen ? 5 : 0 }]}>
          <CheckBox
            center={true}
            title={t('to-deliver')}
            textStyle={{
              fontSize: 14,
              fontWeight: '400',
              lineHeight: 24,
              letterSpacing: 0,
              textAlign: 'left',
              color: '#001639',
            }}
            checked={selectedCheckbox === 'Delivering'}
            checkedColor={'#001639'}
            uncheckedColor={'#001639'}
            onPress={() => {
              if (selectedCheckbox === 'Delivering') {
                setSelectedCheckbox('');
                handleFilter('');
              } else {
                setSelectedCheckbox('Delivering');
                handleFilter('Delivering');
              }
            }}
            containerStyle={styles.checkBoxInsideContainer}
          />
        </View>
      </View>
    );
  };

  return (
    <Modal visible={visible} transparent={true} style={styles.modal}>
      <View style={styles.container}></View>
      <View style={styles.modalBox}>{renderModal()}</View>
    </Modal>
  );
};
